import { Dispatch } from "redux";
import { EmpReport } from "../../types/EmpReport";
import {
  createEmpReport,
  deleteEmpReport,
  getEmpReports,
  updateEmpReport,
} from "../../services/EmployeeReportService";

// Action types
export enum EmpReportActionList {
  ADD_EMP_REPORT = "ADD_EMP_REPORT",
  EDIT_EMP_REPORT = "EDIT_EMP_REPORT",
  FETCH_EMP_REPORTS = "FETCH_EMP_REPORTS",
  DELETE_EMP_REPORT = "DELETE_EMP_REPORT",
}

// Actions
export interface AddEmpReportAction {
  type: EmpReportActionList.ADD_EMP_REPORT;
  data: EmpReport;
}

export interface EditEmpReportAction {
  type: EmpReportActionList.EDIT_EMP_REPORT;
  data: EmpReport;
  id: number;
}

export interface FetchEmpReportAction {
  type: EmpReportActionList.FETCH_EMP_REPORTS;
  data: EmpReport[];
}

export interface DeleteEmpReportAction {
  type: EmpReportActionList.DELETE_EMP_REPORT;
  data: number;
}

export type EmpReportActions =
  | AddEmpReportAction
  | EditEmpReportAction
  | FetchEmpReportAction
  | DeleteEmpReportAction;

// Action Creators
export const addEmpReportAction = (data: EmpReport) => {
  return async (dispatch: Dispatch) => {
    return createEmpReport(data)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          dispatch<AddEmpReportAction>({
            type: EmpReportActionList.ADD_EMP_REPORT,
            data: response.data.data,
          });
          return Promise.resolve(response.data.message ?? "EmpReport added");
        } else {
          throw new Error(response?.data?.message || "Unknown error");
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to add empReport",
        ),
      );
  };
};
// export const addEmpReportAction = (data: EmpReport) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const response = await createEmpReport(data);
//             console.log("addEmpReportAction response:", response);

//             if ((response.status === 201 || response.status === 200) && response.data?.data) {
//                 dispatch({
//                     type: EmpReportActionList.ADD_EMP_REPORT,
//                     data: response.data.data,
//                 });
//                 return response.data.message ?? "EmpReport created";
//             } else {
//                 return Promise.reject("Invalid response from server.");
//             }
//         } catch (error: any) {
//             console.error("addEmpReportAction error:", error);
//             return Promise.reject(
//                 error?.response?.data?.message ?? "Unable to create empReport"
//             );
//         }
//     };
// };

// export const editEmpReportAction = (id: number, data: EmpReport) => {
//     return async (dispatch: Dispatch) => {
//         console.log(id, data);
//         return updateEmpReport(id,data)
//         .then((response)=>{
//             if(response.status === 200 && response.data?.data){
//                 dispatch<EditEmpReportAction>({
//                     type:EmpReportActionList.EDIT_EMP_REPORT,
//                     data:response.data.data,
//                     id,
//                 });
//                 return Promise.resolve (response.data.message ??"EmpReport updated");
//             }else{
//                 throw{response};
//             }
//         })
//         .catch((error)=>
//             Promise.reject(
//                 error.response?.data?.message ?? "unable to empreport update"
//             )
//         )
//     };
// };
export const editEmpReportAction = (id: number, data: EmpReport) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await updateEmpReport(id, data);
      const updatedData = response.data?.data ?? response.data;

      if (response.status === 200 && response.data) {
        dispatch<EditEmpReportAction>({
          type: EmpReportActionList.EDIT_EMP_REPORT,
          data: updatedData,
          id,
        });
        return Promise.resolve(response.data.message ?? "EmpReport updated");
      } else {
        throw new Error(response?.data?.message || "Unknown error");
      }
    } catch (error: any) {
      console.error("Update EmpReport Error:", error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to update empReport";

      return Promise.reject(errorMessage);
    }
  };
};

export const fetchEmpReportsAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getEmpReports();
    dispatch<FetchEmpReportAction>({
      type: EmpReportActionList.FETCH_EMP_REPORTS,
      data: response,
    });
  };
};

export const deleteEmpReportAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteEmpReport(id)
      .then((response) => {
        if (response.status === 200) {
          dispatch<DeleteEmpReportAction>({
            type: EmpReportActionList.DELETE_EMP_REPORT,
            data: id,
          });
          return Promise.resolve(response.data.message ?? "EmpReport deleted");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to delete empReport",
        ),
      );
  };
};
